import { app } from '../../../app';

app.factory('LicenseViolationService', LicenseViolationService);

/** @ngInject */
function LicenseViolationService($resource) {
    var rootUrl = '/app/rest/company/:id/onprem/get-violations';
    return {
        licenseViolations :  $resource(rootUrl),
    }
}





// WEBPACK FOOTER //
// ./src/portal/states/company/license-violation/license-violation.service.js